import { render, staticRenderFns } from "./selectFile.vue?vue&type=template&id=edcd8af4&"
import script from "./selectFile.vue?vue&type=script&lang=ts&"
export * from "./selectFile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports